export { default } from './TableFooter';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/TableFooter/index.js
// module id = 816
// module chunks = 121